export function findRelativeParent(targetElement: Element) {
  if (targetElement.getRootNode() === targetElement) {
    return undefined;
  }

  let { parentElement } = targetElement;

  while (parentElement) {
    const { position } = getComputedStyle(parentElement);

    if (['fixed', 'relative', 'absolute'].includes(position)) {
      return parentElement;
    }

    parentElement = parentElement.parentElement;
  }

  return document.documentElement;
}
